<template>
  <div>
    <ComponentCoverTest />
  </div>
</template>

<script>
import ComponentCoverTest from "ninenine-white-label/src/components/Tests/ComponentCoverTest.vue";

export default {
  name: "CoverTest",

  components: {
    ComponentCoverTest,
  },
};
</script>

<style lang="scss" scoped>
/deep/.tabs {
  .btn {
    white-space: normal;
  }
}

/deep/.cover-test {
  min-height: 100vh;
  h5 {
    font-size: 22px;
    margin: 0;
    padding: 0;
  }

  .icon-file {
    width: 41px;
    float: left;
    margin-right: 10px;
  }

  .title-opportunity {
    text-transform: capitalize;
  }

  .box-test {
    border: 1px solid #d7dbdc;
    background-color: #f7f7f7;
    border-radius: 5px;
    color: #565a5c;
    padding: 20px;
    display: inline-block;

    .total {
      font-size: 14px;
      line-height: 1.42857;
      color: #888d90;
      margin: 0;
      padding: 0 0 4px 30px;
      background-size: 20px;
      background: url("../../assets/images/ok-check.svg") no-repeat;

      span {
        font-weight: bold;
      }
    }
  }

  .btn-start {
    width: 240px;
    height: 50px;
    font-size: 14px;

    :hover {
      background-color: #376097;
    }
  }
}
</style>
